import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

export const GET_OR_CREATE_TRANSACTION_TEST_NAME = 'getOrCreateTransaction';

export const GET_OR_CREATE_TRANSACTION_CONTROL_NAME = 'control';
export const GET_OR_CREATE_TRANSACTION_VARIANT_NAME = 'variant';

export function isGetOrCreateTransactionActive(): boolean {
    return (
        getAbTestV2(GET_OR_CREATE_TRANSACTION_TEST_NAME)?.variant ===
        GET_OR_CREATE_TRANSACTION_VARIANT_NAME
    );
}

export const trackGetOrCreateTransactionTestVariant = (): void => {
    trackAbTestV2Variant(GET_OR_CREATE_TRANSACTION_TEST_NAME);
};
